import script from "./AppDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppDetailPage.vue?vue&type=style&index=0&id=06bd896a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bd896a"]])

export default __exports__